import { createSelector } from "@ngrx/store";
import { ArrayInterface } from "../../../models/arrayInterface";
import { AppState } from "./../../../models/app.state";

export const arrayRootSelector = (state: AppState) => {
  return state.state.array;
};

export const allArray = createSelector(arrayRootSelector, (array: ArrayInterface[]) => array);
